import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { api, ApiError } from '@/lib/api';

export function MyPlanPrintPage() {
  const navigate = useNavigate();
  const meQuery = useQuery({
    queryKey: ['me'],
    queryFn: api.me,
  });

  const bookingsQuery = useQuery({
    queryKey: ['my-bookings'],
    queryFn: api.myBookings,
    enabled: meQuery.isSuccess,
  });

  useEffect(() => {
    if (meQuery.error instanceof ApiError && meQuery.error.status === 401) {
      navigate('/login');
    }
  }, [meQuery.error, navigate]);

  if (!meQuery.data) {
    return <p className="print-loading">Druckansicht wird geladen…</p>;
  }

  return (
    <div className="print-page">
      <div className="print-toolbar">
        <button className="button" type="button" onClick={() => window.print()}>
          Drucken / PDF
        </button>
      </div>

      <article className="print-sheet">
        <header className="print-sheet__header">
          <p>!GROW 2026</p>
          <h1>Mein Plan</h1>
          <strong>{meQuery.data.attendee.display_name}</strong>
        </header>

        <div className="print-list">
          {bookingsQuery.data?.bookings.map((booking) => (
            <section className="print-card" key={booking.bookingId}>
              <div className="print-card__row">
                <strong>{booking.startTime} – {booking.endTime}</strong>
                <span className="room-label">{booking.roomName}</span>
              </div>
              <h2>{booking.title}</h2>
              {booking.subtitle ? <p>{booking.subtitle}</p> : null}
              <p>Referentin: {booking.speaker ?? 'Wird ergänzt'}</p>
            </section>
          ))}
        </div>
      </article>
    </div>
  );
}
